module.exports = __webpack_public_path__ + "static/img/10.33ca75c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/12/eng/10.png
// module id = tYNq
// module chunks = 0